module.exports = __webpack_public_path__ + "static/media/cekarna1.25930fab.webp";